import { z } from "zod";
import { ENhrStatus } from "@zeal/common/dist/uhura";

const nhrStatusEnumValues = Object.values(ENhrStatus) as [string, ...string[]];

export const newHireReportingSummaryItemSchema = z.object({
  sent_date: z.string(),
  state: z.string(),
  count: z.number(),
});

export type INewHireReportingSummaryItem = z.infer<
  typeof newHireReportingSummaryItemSchema
>;

export const getNewHireReportingSummaryRequestSchema = z
  .object({
    start_date: z.string().optional(),
    end_date: z.string().optional(),
    status: z.string().optional(),
  })
  .superRefine((data, ctx) => {
    if (!data.status?.trim()) {
      return;
    }
    const tokens = data.status
      .split(",")
      .map((s) => s.trim())
      .filter(Boolean);
    for (const token of tokens) {
      if (!nhrStatusEnumValues.includes(token)) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: `Invalid NHR status: ${token}`,
          path: ["status"],
        });
      }
    }
  });

export type TGetNewHireReportingSummaryRequest = z.infer<
  typeof getNewHireReportingSummaryRequestSchema
>;

export const getNewHireReportingSummaryResponseSchema = z.object({
  data: z.array(newHireReportingSummaryItemSchema),
});

export type TGetNewHireReportingSummaryResponse = z.infer<
  typeof getNewHireReportingSummaryResponseSchema
>;
